import { annotationsspec } from './Annotations'

const russiasoutheast = {
  label_de: 'Russland',
  label_fr: 'Russie',
  position: { x: 94, y: 7 },
  position_mob: { x: 65, y: 18 },
  type: 'country',
}
const blackseasoutheast = {
  label_de: 'Schwarzes Meer',
  label_fr: 'Mer Noire',
  position: { x: 70, y: 94 },
  position_mob: { x: 75, y: 92 },
  type: 'region',
}
const chersonsoutheast = {
  label_de: 'Cherson',
  label_fr: 'Cherson',
  position: { x: 33, y: 78 },
  position_mob: { x: 53, y: 60 },
  type: '_point_bottom_left',
}

const krimsoutheast = {
  label_de: 'Krim',
  label_fr: 'Crimea',
  position: { x: 46, y: 96 },
  position_mob: { x: 67, y: 74 },
  type: 'region',
}

const charkiwsoutheast = {
  label_de: 'Charkiw',
  label_fr: 'Kharkiv',
  position: { x: 63.5, y: 7 },
  position_mob: { x: 79, y: 22 },
  type: '_center_point_bottom',
}
const charkiwnortheast = {
  label_de: 'Charkiw',
  label_fr: 'Kharkiv',
  position: { x: 63, y: 30 },
  position_mob: { x: 65, y: 30 },
  type: '_center_point_bottom',
}
const dnipronortheast = {
  label_de: 'Dnipro',
  label_fr: 'Dnipropetrovsk',
  position: { x: 49, y: 76.5 },
  type: '_center_point_bottom',
}
const donezksoutheast = {
  label_de: 'Donezk',
  label_fr: 'Donetsk',
  position: { x: 77, y: 49 },
  position_mob: { x: 90, y: 44 },
  type: '_point_center_top',
}
const donezkbachmut = {
  label_de: 'Donezk',
  label_fr: 'Donetsk',
  position: { x: 50, y: 94 },
  position_mob: { x: 67, y: 89 },
  type: '_point_center_top',
}
const bachmut = {
  label_de: 'Bachmut',
  label_fr: 'Bakhmut',
  position: { x: 55, y: 50 },
  position_mob: { x: 70, y: 45 },
  type: '_point_center_top',
}

const luhansksoutheast = {
  label_de: 'Luhansk',
  label_fr: 'Luhansk',
  position: { x: 90, y: 37 },
  type: '_point_center_top',
}
const luhanskbachmut = {
  label_de: 'Luhansk',
  label_fr: 'Luhansk',
  position: { x: 96, y: 51 },
  type: '_point_center_top',
}

export const firstarrows = [
  {
    position: { x: 73, y: 73 },
    position_mob: { x: 68, y: 62 },
    rotation: 240,
    type: '_arrow_curved',
  },
  {
    position: { x: 70, y: 73 },
    position_mob: { x: 64, y: 63 },
    rotation: 110,
    type: '_arrow_curved_left',
  },
  {
    position: { x: 53, y: 17 },
    position_mob: { x: 45, y: 20 },
    rotation: -10,
    type: '_arrow_curved_left',
  },
  {
    position: { x: 58, y: 11 },
    position_mob: { x: 51, y: 15 },
    rotation: -10,
    type: '_arrow_curved',
  },
  {
    position: { x: 65.5, y: 8 },
    position_mob: { x: 60, y: 13 },
    rotation: -10,
    type: '_arrow_curved_left',
  },
  {
    position: { x: 71.5, y: 16.5 },
    position_mob: { x: 67, y: 20.5 },
    rotation: 30,
    type: '_arrow_curved_left',
  },
  {
    position: { x: 79.5, y: 28.5 },
    position_mob: { x: 76.5, y: 28 },
    rotation: 10,
    type: '_arrow_curved_left',
  },
  {
    position: { x: 96, y: 39 },
    position_mob: { x: 95, y: 39 },
    rotation: 90,
    type: '_arrow_curved',
  },
]
const as = annotationsspec
export const countries = [
  as.russia,
  as.belarus,
  as.poland,
  as.slowakia,
  as.hungary,
  as.romania,
  as.moldova,
  as.blacksea,
]
export const annos: { [key: string]: AnnotationSpec[] } = {
  '2022-02-23': [
    as.krim,
    as.donezk,
    as.luhansk,
    as.kiew,
    {
      position: { x: 91, y: 56.5 },
      position_mob: { x: 90, y: 50 },
      rotation: 160,
      type: '_arrow_curved',
    },
    ...countries,
  ],
  '2022-02-25': [
    as.krim,
    { ...as.kiew, type: '_point_bottom_center_bomb_bold' },
    { ...as.charkiw, type: '_point_bottom_center_bomb_bold' },
    { ...as.dnipro, type: '_point_bottom_center_bomb_bold' },
    { ...as.kramatorsk, type: '_point_bottom_center_bomb_bold' },
    { ...as.berdjansk, type: '_point_bottom_center_bomb_bold' },
    ...countries,
    ...firstarrows,
  ],
  '2022-03-02': [
    as.krim,
    as.kiew,
    as.charkiw,
    { ...as.mykolajiw, type: '_point_top_left' },
    { ...as.mariupol, type: '_point_top_right_bg' },
    { ...as.sumy, type: '_point_bottom_center' },
    {
      position: { x: 54, y: 21 },
      position_mob: { x: 45, y: 24 },
      rotation: 30,
      type: '_arrow_straight',
    },
    {
      position: { x: 80, y: 64 },
      position_mob: { x: 76, y: 56 },
      rotation: -60,
      type: '_arrow_straight',
    },

    {
      position: { x: 88, y: 57 },
      position_mob: { x: 85.5, y: 50 },
      rotation: 79,
      type: '_arrow_straight',
    },
    {
      position: { x: 83, y: 33 },
      position_mob: { x: 79.5, y: 32 },
      rotation: -20,
      type: '_arrow_straight',
    },
    {
      position: { x: 67, y: 21 },
      position_mob: { x: 61.5, y: 22.5 },
      rotation: 90,
      type: '_arrow_curved',
    },
    {
      position: { x: 74, y: 68 },
      position_mob: { x: 69.5, y: 58 },
      rotation: 170,
      type: '_arrow_curved_left',
    },
    {
      position: { x: 67, y: 70 },
      position_mob: { x: 64, y: 60 },
      rotation: 150,
      type: '_arrow_curved',
    },
    ...countries,
  ],
  '2022-03-24': [
    ...countries,
    as.kiew,

    as.mariupol,
    as.sumy,
    as.cherson,
    as.charkiw,
    as.krim,
    {
      position: { x: 90, y: 40 },
      position_mob: { x: 88.5, y: 37 },
      radius: window.innerWidth < 711 ? 15 : 10,
      type: 'circle',
    },
    {
      position: { x: 63, y: 23 },
      position_mob: { x: 56.5, y: 25 },
      rotation: 120,
      type: '_arrow_straight',
    },
    {
      position: { x: 84, y: 33 },
      position_mob: { x: 79, y: 31.5 },
      rotation: -30,
      type: '_arrow_straight',
    },
    {
      position: { x: 92, y: 39 },
      position_mob: { x: 90, y: 37 },
      rotation: 120,
      type: '_arrow_curved_left',
    },
    {
      position: { x: 73, y: 67 },
      position_mob: { x: 68, y: 58 },
      rotation: 170,
      type: '_arrow_straight',
    },
  ],
  '2022-03-05': [
    ...countries,
    as.krim,
    as.cherson,

    {
      ...as.kiew,
      type: '_bg_bottom_left_point',
    },
    {
      ...as.charkiw,
      type: '_bg_bottom_right_point',
    },
    as.sumy,
    as.mariupol,

    {
      position: { x: 63, y: 23 },
      position_mob: { x: 57, y: 25 },
      rotation: 120,
      type: '_arrow_straight',
    },
    {
      position: { x: 83, y: 33 },
      position_mob: { x: 79, y: 31.5 },
      rotation: -30,
      type: '_arrow_straight',
    },

    {
      position: { x: 73, y: 67 },
      position_mob: { x: 68, y: 58 },
      rotation: 170,
      type: '_arrow_straight',
    },
    {
      position: { x: 92, y: 45 },
      position_mob: { x: 90, y: 42 },
      rotation: 170,
      type: '_arrow_curved_left',
    },
  ],
  '2022-03-23': [
    ...countries,
    as.krim,
    as.charkiw,
    as.kiew,
    as.sumy,
    as.mariupol,
    as.mykolajiw,
    {
      position: { x: 65, y: 70 },
      position_mob: { x: 60, y: 59 },
      radius: window.innerWidth < 711 ? 25 : 12,
      type: 'circle',
    },
    {
      position: { x: 56, y: 29.5 },
      position_mob: { x: 50, y: 30 },
      radius: window.innerWidth < 711 ? 25 : 12,
      type: 'circle',
    },
    {
      position: { x: 81, y: 35 },
      position_mob: { x: 77, y: 34 },
      radius: window.innerWidth < 711 ? 25 : 12,
      type: 'circle',
    },
    {
      position: { x: 63, y: 66 },
      position_mob: { x: 55, y: 56 },
      rotation: 0,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 52.5, y: 29.5 },
      position_mob: { x: 43.5, y: 30 },
      rotation: 260,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 78.5, y: 33 },
      position_mob: { x: 75, y: 33 },
      rotation: 195,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 80, y: 65 },
      position_mob: { x: 77, y: 55.5 },
      rotation: -70,
      type: '_arrow_straight',
    },
  ],
  '2022-04-06': [
    as.krim,
    as.charkiw,
    // as.mariupol,
    as.mykolajiw,
    ...countries,
    { ...as.butcha, type: '_point_bg_left_top' },
    {
      position: { x: 65.5, y: 7.5 },
      position_mob: { x: 41, y: 19 },
      rotation: 220,
      type: '_arrow_straight_grey',
    },
    {
      position: { x: 59, y: 10 },
      position_mob: { x: 51, y: 15 },
      rotation: 220,
      type: '_arrow_straight_grey',
    },
    {
      position: { x: 50, y: 15 },
      position_mob: { x: 59, y: 13.5 },
      rotation: 220,
      type: '_arrow_straight_grey',
    },
    {
      position: { x: 72, y: 17 },
      position_mob: { x: 67, y: 21 },
      rotation: -70,
      type: '_arrow_straight_grey',
    },
    {
      position: { x: 65.5, y: 13.5 },
      position_mob: { x: 41, y: 24.5 },
      rotation: 220,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 59, y: 16 },
      rotation: 220,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 50, y: 20 },
      position_mob: { x: 59, y: 19 },
      rotation: 220,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 69, y: 19 },
      position_mob: { x: 63, y: 23 },
      rotation: -70,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 84, y: 34 },
      position_mob: { x: 81, y: 34 },
      rotation: 45,
      type: '_arrow_straight',
    },
    as.kiew,
  ],
  '2022-04-07': [
    chersonsoutheast,
    krimsoutheast,
    charkiwsoutheast,
    luhansksoutheast,
    donezksoutheast,
    {
      label_de: 'Mikolajiw',
      label_fr: 'Mykolajiw',
      position: { x: 28, y: 71 },
      position_mob: { x: 49, y: 55 },
      type: window.innerWidth < 711 ? '_point_top_left' : '_point_bottom_left',
    },

    {
      label_de: 'Kramatorsk',
      label_fr: 'Kramatorsk',
      position: { x: 75, y: 34 },
      position_mob: { x: 89, y: 36 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      position: { x: 71, y: 14 },
      position_mob: { x: 84, y: 23 },
      rotation: 45,
      type: '_arrow_straight',
    },

    {
      label_de: 'Donbass',
      label_fr: 'Donbass',
      position: { x: 65, y: 36 },
      position_mob: { x: 75, y: 49 },
      type: 'bg_left_top_hidearrow',
    },
    blackseasoutheast,
  ],
  '2022-04-14': [
    chersonsoutheast,
    krimsoutheast,
    charkiwsoutheast,
    luhansksoutheast,
    donezksoutheast,
    {
      label_de: 'Mikolajiw',
      label_fr: 'Mykolajiw',
      position: { x: 28, y: 71 },
      position_mob: { x: 49, y: 55 },
      type: window.innerWidth < 711 ? '_point_top_left' : '_point_bottom_left',
    },
    {
      label_de: 'Moskwa',
      label_fr: 'Moskwa',
      position: { x: 73.5, y: 74 },
      position_mob: { x: 87, y: 58 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      label_de: 'Donbass',
      label_fr: 'Donbass',
      position: { x: 65, y: 36 },
      position_mob: { x: 75, y: 49 },
      type: 'bg_left_top_hidearrow',
    },
    {
      position: { x: 66, y: 59 },
      position_mob: { x: 79, y: 52 },
      rotation: 225,
      type: '_arrow_straight',
    },
    {
      position: { x: 75, y: 17 },
      position_mob: { x: 87, y: 25 },
      rotation: 90,
      type: '_arrow_straight',
    },
    blackseasoutheast,
  ],
  '2022-05-18': [
    donezksoutheast,
    luhansksoutheast,
    chersonsoutheast,
    krimsoutheast,
    charkiwsoutheast,

    {
      label_de: 'Mikolajiw',
      label_fr: 'Mykolajiw',
      position: { x: 28, y: 71 },
      type: '_point_bottom_left',
    },
    {
      label_de: 'Mariupol',
      label_fr: 'Marioupol',
      position: { x: 75.5, y: 68.5 },
      position_mob: { x: 88.5, y: 54.5 },
      type: '_point_bottom_center',
    },
    {
      position: { x: 75.5, y: 68.5 },
      position_mob: { x: 88.5, y: 54.5 },
      radius: window.innerWidth < 711 ? 15 : 7,
      type: 'circle',
    },
    blackseasoutheast,
    {
      position: { x: 66, y: 5 },
      position_mob: { x: 78, y: 20 },
      rotation: -90,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 31, y: 64.5 },
      position_mob: { x: 50, y: 51 },
      rotation: 45,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 38, y: 55 },
      position_mob: { x: 56, y: 45 },
      rotation: 45,
      type: '_arrow_straight_blue',
    },

    {
      position: { x: 38, y: 66 },
      position_mob: { x: 76, y: 52 },
      rotation: 225,
      type: '_arrow_straight',
    },
    {
      position: { x: 78, y: 22 },
      position_mob: { x: 90, y: 28 },
      rotation: 70,
      type: '_arrow_straight',
    },
    // {
    //   position: { x: 72, y: 5 },
    //   position_mob: { x: 84, y: 19 },
    //   rotation: 10,
    //   type: '_arrow_curved_grey',
    // },
    {
      label_de: 'Donbass',
      label_fr: 'Donbass',
      position: { x: 65, y: 36 },
      position_mob: { x: 75, y: 49 },
      type: 'bg_left_top_hidearrow',
    },
  ],
  '2022-05-30': [
    chersonsoutheast,
    krimsoutheast,
    charkiwsoutheast,
    donezksoutheast,
    luhansksoutheast,
    {
      label_de: 'Mariupol',
      label_fr: 'Marioupol',
      position: { x: 75.5, y: 68.5 },
      position_mob: { x: 88.5, y: 54.5 },
      type: '_point_bottom_center',
    },
    blackseasoutheast,
    {
      label_de: 'Mikolajiw',
      label_fr: 'Mykolajiw',
      position: { x: 28, y: 71 },
      type: '_point_bottom_left',

    },
    {
      label_de: 'Donbass',
      label_fr: 'Donbass',
      position: { x: 65, y: 36 },
      position_mob: { x: 75, y: 49 },
      type: 'bg_left_top_hidearrow',
    },
    {
      position: { x: 66, y: 5 },
      position_mob: { x: 78, y: 20 },
      rotation: -90,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 31, y: 64.5 },
      position_mob: { x: 50, y: 49 },
      rotation: 45,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 38, y: 55 },
      position_mob: { x: 56, y: 43 },
      rotation: 45,
      type: '_arrow_straight_blue',
    },

    {
      position: { x: 38, y: 65 },
      position_mob: { x: 56, y: 54 },
      rotation: 45,
      type: '_arrow_straight_grey',
    },

    {
      position: { x: 77, y: 24 },
      position_mob: { x: 89, y: 29 },
      rotation: 70,
      type: '_arrow_straight',
    },
    {
      position: { x: 81, y: 34 },
      position_mob: { x: 91, y: 40 },
      rotation: -180,
      type: '_arrow_straight',
    },
  ],
  '2022-06-30': [
    // ODESSA VIEW
    {
      label_de: 'Cherson',
      label_fr: 'Cherson',
      position: { x: 76, y: 40 },
      position_mob: { x: 79.5, y: 34 },
      type: '_point_bottom_left',
    },
    {
      label_de: 'Krim',
      label_fr: 'Crimea',
      position: { x: 90, y: 65 },
      position_mob: { x: 93, y: 48 },
      type: 'region',
    },
    {
      label_de: 'Schwarzes Meer',
      label_fr: 'Mer Noire',
      position: { x: 71, y: 80 },
      position_mob: { x: 75, y: 74 },
      type: 'region',
    },
    {
      label_de: 'Schlangeninsel',
      label_fr: 'Île aux Serpents',
      position: { x: 58, y: 64 },
      position_mob: { x: 60, y: 49 },
      type: 'bg_left_bottom_point',
    },

    {
      label_de: 'Odessa',
      label_fr: 'Odessa',
      position: { x: 62, y: 42.5 },
      position_mob: { x: 65, y: 36 },
      type: '_point_center_top',
    },
    {
      label_de: 'Mikolajiw',
      label_fr: 'Mykolayiv',
      position: { x: 71.5, y: 35 },
      position_mob: { x: 75, y: 30.5 },
      type: "_point_top_left",
    },
    {
      label_de: 'Moldawien',
      label_fr: 'Moldavie',
      position: { x: 50, y: 30 },
      type: 'country',
    },
    {
      label_de: 'Rumänien',
      label_fr: 'Roumanie',
      position: { x: 20, y: 50 },
      type: 'country',
    },
  ],
  '2022-07-04': [
    chersonsoutheast,
    krimsoutheast,
    charkiwsoutheast,
    donezksoutheast,
    luhansksoutheast,
    blackseasoutheast,
    {
      label_de: 'Lissitschansk',
      label_fr: 'Lysychansk',
      position: { x: 82, y: 28 },
      position_mob: { x: 93, y: 33 },
      type: window.innerWidth<712?"_point_bottom_right": '_point_top_left',
    },
    {
      position: { x: 82, y: 28 },
      position_mob: { x: 93, y: 33 },
      radius: 10,
      type: 'circle',
    },
    {
      position: { x: 78.5, y: 23 },
      position_mob: { x: 89, y: 28 },
      rotation: 20,
      type: '_arrow_straight',
    },
  ],
  '2022-08-10': [
    // ODESSA VIEW
    {
      label_de: 'Krim',
      label_fr: 'Crimea',
      position: { x: 90, y: 65 },
      position_mob: { x: 95, y: 53 },
      type: 'region',
    },
    {
      label_de: 'Schwarzes Meer',
      label_fr: 'Mer Noire',
      position: { x: 78, y: 83 },
      position_mob: { x: 75, y: 74 },
      type: 'region',
    },  {
      label_de: 'Odessa',
      label_fr: 'Odessa',
      position: { x: 62, y: 42.5 },
      position_mob: { x: 65, y: 36 },
      type: '_point_center_top',
    },
    {
      label_de: 'Cherson',
      label_fr: 'Cherson',
      position: { x: 76, y: 40 },
      position_mob: { x: 79.5, y: 34 },
      type: '_point_bottom_left',
    },
    {
      position: { x: 78, y: 35 },
      position_mob: { x: 82, y: 30 },
      radius: window.innerWidth < 711 ? 35 : 15,
      type: 'circle',
    },
    {
      label_de: 'Saki',
      label_fr: 'Saki',
      position: { x: 81, y: 67 },
      position_mob: { x: 85, y: 52.5 },
      type: 'bg_left_top',
    },
    {
      position: { x: 70, y: 31 },
      position_mob: { x: 72, y:26 },
      rotation: 0,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 79, y: 20 },
      position_mob: { x: 83, y: 18 },
      rotation: 45,
      type: '_arrow_straight_blue',
    },
    // {
    //   label_de: 'Mikolajiw',
    //   label_fr: 'Mykolayiv',
    //   position: { x: 71.5, y: 35 },
    //   position_mob: { x: 75, y: 30.5 },
    //   type: '_point_top_left',
    // },
    {
      label_de: 'Moldawien',
      label_fr: 'Moldavie',
      position: { x: 50, y: 30 },
      type: 'country',
    },
    {
      label_de: 'Rumänien',
      label_fr: 'Roumanie',
      position: { x: 20, y: 50 },
      type: 'country',
    },
  ],
  '2022-08-31': [
    // ODESSA VIEW
    {
      position: { x: 70, y: 31 },
      position_mob: { x: 72, y:26 },
      rotation: 0,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 79, y: 20 },
      position_mob: { x: 83, y: 18 },
      rotation: 45,
      type: '_arrow_straight_blue',
    },
    {
      label_de: 'Odessa',
      label_fr: 'Odessa',
      position: { x: 62, y: 42.5 },
      position_mob: { x: 65, y: 36 },
      type: '_point_center_top',
    },
    {
      label_de: 'Mikolajiw',
      label_fr: 'Mykolayiv',
      position: { x: 71.5, y: 35 },
      type: '_point_top_left',
    },
    {
      label_de: 'Moldawien',
      label_fr: 'Moldavie',
      position: { x: 50, y: 30 },
      type: 'country',
    },
    {
      label_de: 'Rumänien',
      label_fr: 'Roumanie',
      position: { x: 20, y: 50 },
      type: 'country',
    },
    {
      label_de: 'Nowa Kachowka',
      label_fr: 'Novoazovsk',
      position: { x: 81, y: 39.5 },
      position_mob: { x: 85, y: 34 },
      type: window.innerWidth < 711 ? '_point_bg_right_top' : '_point_bg_left_top',
    },
    {
      label_de: 'Krim',
      label_fr: 'Crimea',
      position: { x: 90, y: 65 },
      position_mob: { x: 95, y: 53 },
      type: 'region',
    },
    {
      label_de: 'Schwarzes Meer',
      label_fr: 'Mer Noire',
      position: { x: 78, y: 83 },
      position_mob: { x: 75, y: 74 },
      type: 'region',
    },
    {
      label_de: 'Cherson',
      label_fr: 'Cherson',
      position: { x: 76, y: 40 },
      position_mob: { x: 79.5, y: 34 },
      type: '_point_bottom_left',
    },
  ],
  '2022-09-06': [
    charkiwnortheast,
    dnipronortheast,
    {
      label_de: 'Balaklija',
      label_fr: 'Balaklija',
      position: { x: 71, y: 47 },
      position_mob: { x: 77.5, y: 46 },
      type: '_point_bg_left_top',
    },
    {
      position: { x: 68, y: 32 },
      position_mob: { x: 73, y: 31 },
      rotation: -45,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 67, y: 40},
      position_mob: { x: 70, y: 39 },
      rotation: -45,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 66, y: 26 },
      position_mob: { x: 71, y: 25 },
      rotation: -90,
      type: '_arrow_straight_blue',
    },
    {
      label_de: 'Lissitschansk',
      label_fr: 'Lysychansk',
      position: { x: 90, y:62 },
      type: '_point_top_center',
    },
    {
      label_de: 'Donezk',
      label_fr: 'Donetsk',
      position: { x: 85, y:90 },
      type: '_point_top_center',
    },
  ],
  '2022-09-12': [
    charkiwnortheast,

    dnipronortheast,
    {
      label_de: 'Lissitschansk',
      label_fr: 'Lysychansk',
      position: { x: 90, y:62 },
      type: '_point_top_center',
    },
    {
      label_de: 'Donezk',
      label_fr: 'Donetsk',
      position: { x: 85, y:90 },
      type: '_point_top_center',
    },
    {
      label_de: 'Kupjansk',
      label_fr: 'Kupyansk',
      position: { x: 81, y: 38 },
      position_mob: { x: 92, y: 37 },
      type: '_point_bg_right_top',
    },

    {
      label_de: 'Isjum',
      label_fr: 'Izium',
      position: { x: 76, y: 55 },
      position_mob: { x: 85, y: 53 },
      type: '_point_bg_right_bottom',
    },
    {
      position: { x: 76, y: 40 },
      position_mob: { x: 84, y: 41 },
      rotation: -20,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 79, y: 28 },
      position_mob: { x: 90, y: 26 },
      rotation: -20,
      type: '_arrow_curved_blue',
    },
    {
      position: { x: 74, y: 50 },
      position_mob: { x: 83, y: 49 },
      rotation: -90,
      type: '_arrow_curved_blue_left',
    },
    {
      position: { x: 80, y: 63 },
      position_mob: { x: 91, y: 60 },
      rotation: -155,
      type: '_arrow_curved_blue_left',
    },
    {
      position: { x: 82, y: 44 },
      position_mob: { x: 92, y: 44 },
      rotation: -20,
      type: '_arrow_straight_grey',
    },
    {
      position: { x: 82, y: 52 },
      position_mob: { x: 93, y: 34 },
      rotation: -20,
      type: '_arrow_straight_grey',
    },
    {
      position: { x: 84, y: 35 },
      position_mob: { x: 90, y: 52 },
      rotation: -20,
      type: '_arrow_straight_grey',
    },
  ],
  '2022-09-30': [
    as.kiew,
    as.krim,
    as.charkiw,
    ...countries,
    {
      label_de: 'Donezk',
      label_fr: 'Donetsk',
      position: { x: 87, y: 54 },
      position_mob: { x: 80, y: 46 },
      type: '_bg_center',
    },
    {
      label_de: 'Luhansk',
      label_fr: 'Luhansk',
      position: { x: 92, y: 42 },
      position_mob: { x: 91, y: 34 },
      type: '_bg_center',
    },
    {
      label_de: 'Saporischschja',
      label_fr: 'Saporoshje',
      position: { x: 76, y: 57 },
      position_mob: { x: 85, y: 62 },
      type: '_bg_center',
    },
    {
      label_de: 'Cherson',
      label_fr: 'Cherson',
      position: { x: 70, y: 71 },
      position_mob: { x: 60, y: 56 },
      type: '_bg_center',
    },
    {
      position: { x: 84, y: 36 },
      position_mob: { x: 81, y: 34 },
      rotation: -20,
      type: '_arrow_straight_blue',
    },
  ],
  '2022-10-08': [
    as.kiew,
    as.krim,
    as.charkiw,
    as.cherson,
    as.mariupol,
    ...countries,
    {
      label_de: 'Kertsch-Brücke',
      label_fr: 'Pont de Kerch',
      position: { x: 82.25, y: 86 },
      position_mob: { x: 80, y: 73 },
      type: 'bg_left_top',
    },
    {
      position: { x: 84, y: 42 },
      position_mob: { x: 81, y: 40 },
      rotation: -70,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 70, y: 60 },
      position_mob: { x: 65, y: 52 },
      rotation: 90,
      type: '_arrow_straight_blue',
    },
  ],

  '2022-10-10': [
    as.krim,
    { ...as.kiew, type: '_point_bottom_center_bomb_bold' },
    { ...as.charkiw, type: '_point_bottom_center_bomb_bold' },
    { ...as.dnipro, type: '_point_bottom_center_bomb_bold' },
    ...countries,
    {
      label_de: 'Lwiw',
      label_fr: 'Lviv',
      position: { x: 31, y: 38 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      label_de: 'Chmelnizki',
      label_fr: 'Hmelnitski',
      position: { x: 43, y: 43 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      label_de: 'Schitomir',
      label_fr: 'Sytomir',
      position: { x: 50, y: 34 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      label_de: 'Sumi',
      label_fr: 'Sumy',
      position: { x: 75, y: 27 },
      position_mob: { x: 73, y: 26 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      label_de: 'Saporischschja',
      label_fr: 'Saporoshje',
      position: { x: 77, y: 59 },
      position_mob: { x: 74, y: 52 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      label_de: 'Mikolajiw',
      label_fr: 'Mykolayiv',
      position: { x: 64, y: 67 },
      position_mob: { x: 58, y: 57 },
      type: '_point_top_center_bomb_bold',
    },
    {
      label_de: 'Odessa',
      label_fr: 'Odessa',
      position: { x: 59, y: 72 },
      position_mob: { x: 53, y: 61 },
      type: '_point_bottom_center_bomb_bold',
    },
    {
      position: { x: 85, y: 41 },
      position_mob: { x: 81, y: 40 },
      rotation: -70,
      type: '_arrow_straight_blue',
    },
  ],
  '2022-11-15': [
    as.krim,
    as.kiew,
    as.charkiw,
    { ...as.cherson, type: '_point_top_right' },
    {
      position: { x: 68, y: 66 },
      position_mob: { x: 64, y: 59 },
      radius: window.innerWidth < 711 ? 20 : 10,
      type: 'circle',
    },
    {
      position: { x: 65, y: 64 },
      position_mob: { x: 57.5, y: 55 },
      rotation: 0,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 67, y: 62 },
      position_mob: { x: 61, y: 52 },
      rotation: 0,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 70, y: 66 },
      position_mob: { x: 65, y: 56 },
      rotation: 0,
      type: '_arrow_straight_grey',
    },
    {
      position: { x: 68, y: 69.5 },
      position_mob: { x: 61, y: 59 },
      rotation: 0,
      type: '_arrow_straight_grey',
    },
    ...countries,
  ],
  '2022-12-01': [
    as.krim,
    { ...as.kiew, type: '_point_bottom_center_bomb_bold' },
    { ...as.dnipro, type: '_point_bottom_center_bomb_bold' },
    { ...as.odessa, type: '_point_bottom_center_bomb_bold' },
    { ...as.charkiw, type: '_point_bottom_center_bomb_bold' },
    as.cherson,

    ...countries,
  ],
  '2023-01-02': [
    as.krim,
    as.kiew,

    as.charkiw,
    as.cherson,

    {
      position: { x: 85, y: 40 },
      position_mob: { x: 81, y: 34 },
      rotation: -45,
      type: '_arrow_straight_blue',
    },
    {
      position: { x: 84, y: 36 },
      position_mob: { x: 81, y: 38 },
      rotation: -45,
      type: '_arrow_straight_blue',
    },
    {
      label_de: 'Makijiwka',
      label_fr: 'Makiyivka',
      position: { x: 89, y: 55 },
      position_mob: { x: 89, y: 49 },
      type: '_point_bottom_center_bomb_bold',
    },

    ...countries,
  ],
  '2023-01-10': [
    luhanskbachmut,
    { ...bachmut, type: '_point_bg_right_top' },

    donezkbachmut,

    {
      label_de: 'Lissitschansk',
      label_fr: 'Lysychansk',
      position: { x: 69, y: 17 },
      position_mob: { x: 92, y: 16 },
      type: '_point_bottom_center',
    },
    {
      position: { x: 56, y: 45 },
      position_mob: { x: 71, y: 50 },
      rotation: 180,
      type: '_arrow_straight',
    },
    {
      position: { x: 58, y: 39.5 },
      position_mob: { x: 72, y: 40 },
      rotation: 180,
      type: '_arrow_straight',
    },
    {
      position: { x: 55, y: 58 },
      position_mob: { x: 75, y: 35 },
      rotation: 180,
      type: '_arrow_straight',
    },
    {
      position: { x: 58, y: 17 },
      position_mob: { x: 75, y: 14 },
      rotation: 240,
      type: '_arrow_curved_blue_left',
    },
  ],
  '2023-01-20': [
    luhanskbachmut,
    { ...bachmut, type: '_center' },

    donezkbachmut,
    {
      position: { x: 56, y: 44 },
      position_mob: { x: 72, y: 39 },
      rotation: 200,
      type: '_arrow_curved',
    },
    {
      position: { x: 59, y: 11 },
      position_mob: { x: 75, y: 8 },
      rotation: 90,
      type: '_arrow_straight',
    },
    {
      position: { x: 59, y: 39 },
      position_mob: { x: 76, y: 34 },
      rotation: 60,
      type: '_arrow_curved_left',
    },
    {
      label_de: 'Soledar',
      label_fr: 'Séleucie',
      position: { x: 58, y: 44 },
      position_mob: { x: 74, y: 39 },
      type: 'bg_top_right',
    },
    {
      position: { x: 55, y: 57 },
      position_mob: { x: 70, y: 52 },
      rotation: 180,
      type: '_arrow_straight',
    },
    {
      label_de: 'Lissitschansk',
      label_fr: 'Lysychansk',
      position: { x: 69, y: 17 },
      position_mob: { x: 71, y: 58 },
      type: '_point_bottom_center',
    },
  ],
  '2023-02-16': [
    luhanskbachmut,
    { ...bachmut, type: '_center' },

    donezkbachmut,
    {
      label_de: 'Slowjansk',
      label_fr: 'Sloviansk',
      position: { x: 42, y: 28 },
      position_mob: { x: 50, y: 24 },
      type:window.innerWidth<712?"_point_bg_top_left": '_point_bg_top_right',
    },
    {
      label_de: 'Kramatorsk',
      label_fr: 'Kramatorsk',
      position: { x: 40, y: 39 },
      position_mob: { x: 49, y: 35 },
      type:window.innerWidth<712?"_point_bg_bottom_left": '_point_bg_top_right',
    },
    {
      label_de: 'Siwersk',
      label_fr: 'Siversk',
      position: { x: 59, y: 26 },
      position_mob: { x: 76, y: 22 },
      type:window.innerWidth<712?"_point_bg_bottom_left": '_point_bg_top_right',
    },
    {
      position: { x: 56, y: 11 },
      position_mob: { x: 72, y: 8 },
      rotation: 130,
      type: '_arrow_straight',
    },
    {
      position: { x: 53, y: 41 },
      position_mob: { x: 67, y: 37 },
      rotation: 20,
      type: '_arrow_curved_left',
    },
    {
      position: { x: 51, y: 55 },
      position_mob: { x: 65, y: 49 },
      rotation: -180,
      type: '_arrow_curved',
    },
    {
      label_de: 'Lissitschansk',
      label_fr: 'Lysychansk',
      position: { x: 69, y: 17 },
      position_mob: { x: 71, y: 58 },
      type: '_point_bottom_center',
    },
  ],
}
